// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@nrwl/web/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".howToStart_start__FYBWS {\n  white-space: pre-wrap;\n  margin-top: 25px;\n  font-weight: normal;\n  line-height: 120%;\n}\n.howToStart_start__FYBWS h3 {\n  margin-bottom: 15px;\n}\n\n.howToStart_image__wUkP4 {\n  display: block;\n  margin: 0 auto;\n}", ""]);
// Exports
exports.locals = {
	"start": "howToStart_start__FYBWS",
	"image": "howToStart_image__wUkP4"
};
module.exports = exports;
